export default {
  globalAction() {
    console.log("it works");
  },
};
